import SellPage from './sell-page';
export default SellPage;